var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai_replace__prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai_replace__prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0a4.8 4.8 0 10.8 9.533V8.009q-.381.091-.8.091-1.367 0-2.333-.967Q1.5 6.167 1.5 4.8q0-1.367.967-2.333Q3.433 1.5 4.8 1.5q1.367 0 2.333.967.967.966.967 2.333 0 .419-.09.8h1.523A4.8 4.8 0 004.8 0zm8.644.378a.212.212 0 01.38.008l.574 1.218 1.224.64a.212.212 0 01-.008.38l-1.218.575-.64 1.222a.212.212 0 01-.38-.008l-.573-1.215-1.225-.641a.212.212 0 01.008-.38l1.215-.573.643-1.226zM7.2 14V9.2a2 2 0 012-2H14a2 2 0 012 2V14a2 2 0 01-2 2H9.2a2 2 0 01-2-2zm1.5 0q0 .207.146.354.147.146.354.146H14q.207 0 .354-.146.146-.147.146-.354V9.2q0-.207-.146-.354Q14.207 8.7 14 8.7H9.2q-.207 0-.354.146-.146.147-.146.354V14zm-5.571-1.19l.48.582a.75.75 0 101.158-.954l-1.502-1.822a.71.71 0 00-.13-.135.75.75 0 00-1.008.055L.336 12.012a.75.75 0 10.953 1.158l.258-.212q-.065.527.083 1.08.304 1.133 1.319 1.72 1.015.585 2.147.282a.75.75 0 00-.388-1.449q-.532.143-1.009-.133-.477-.275-.62-.807-.117-.44.05-.842z",
    fillRule: "evenodd",
    fill: "#414751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiReplace);
export default __webpack_public_path__ + "static/media/ai-replace.effaca0276ea8ae258ab4cb997bdf7eb.svg";
export { ForwardRef as ReactComponent };